
      let map;
    let markers = [];
    let infoWindow;
    let userCenterMarker = null;

    // 当前选中的分类
    let activeCategory = '全部';

    // 默认位置 (高德坐标系格式: [经度 lng, 纬度 lat])
    const defaultLocation = [114.1871, 22.275567];
    // 用户当前中心点，初始化为默认位置
    let userLocation = [...defaultLocation];


    let showUserCenterMarker = false;

    // 静态门店数据
    const storeDataset =[
  {
    "id": 1,
    "name": "豐澤-又一城店",
    "category": "豐澤",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.179644,
      22.334437
    ],
    "address": "九龍又一城MTR層01號舖",
    "date": [
      {
        "label": "时间",
        "name": "11:00AM-10:00PM (星期一至星期日)"
      }
    ],
    "phone": "",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 2,
    "name": "豐澤-時代廣場店",
    "category": "豐澤",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.1871,
      22.275567
    ],
    "address": "香港銅鑼灣時代廣場8樓818-821號舖及9樓914-915號舖",
    "date": [
      {
        "label": "时间",
        "name": "11:00am-10:00pm (星期一至星期日及公眾假期)"
      }
    ],
    "phone": "",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 3,
    "name": "豐澤-海洋中心店",
    "category": "豐澤",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.173578,
      22.294757
    ],
    "address": "九龍尖沙咀海洋中心3樓333A, 333B, 335-7號舖",
    "date": [
      {
        "label": "时间",
        "name": "11:00am-9:30pm (星期一至星期日及公眾假期)"
      }
    ],
    "phone": "",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 4,
    "name": "豐澤-萬邦行店",
    "category": "豐澤",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.161599,
      22.279644
    ],
    "address": "香港中環皇后大道中33號萬邦行低層地下1-2號舖",
    "date": [
      {
        "label": "时间",
        "name": "10:30am-08:00pm (星期一至星期日及公眾假期)"
      }
    ],
    "phone": "",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 5,
    "name": "豐澤-德福廣場店",
    "category": "豐澤",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.217639,
      22.320216
    ],
    "address": "九龍德福廣場第一期G45-51號舖",
    "date": [
      {
        "label": "时间",
        "name": "11:00am-10:00pm (星期一至星期日及公眾假期)"
      }
    ],
    "phone": "",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 6,
    "name": "豐澤-荃灣廣場店",
    "category": "豐澤",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.116489,
      22.367883
    ],
    "address": "新界荃灣廣場4樓450-453號舖",
    "date": [
      {
        "label": "时间",
        "name": "11:00am-10:00pm (星期一至星期日及公眾假期)"
      }
    ],
    "phone": "",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 7,
    "name": "豐澤-圓方店",
    "category": "豐澤",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.166338,
      22.301769
    ],
    "address": "九龍柯士甸道西一號圓方1樓1050B號舖",
    "date": [
      {
        "label": "时间",
        "name": "11:00am-9:00pm(星期一至星期日及公眾假期)"
      }
    ],
    "phone": "",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 8,
    "name": "豐澤-惠豐中心店",
    "category": "豐澤",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.174766,
      22.31625
    ],
    "address": "九龍旺角彌敦道664號惠豐中心地下4-6號舖",
    "date": [
      {
        "label": "时间",
        "name": "11:00am-10:00pm(星期一至星期日及公眾假期)"
      }
    ],
    "phone": "",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 9,
    "name": "百老匯-恒隆中心店",
    "category": "百老匯",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.19087,
      22.277439
    ],
    "address": "銅鑼灣百德新街恒隆中心地下及地庫",
    "date": [
      {
        "label": "时间",
        "name": "11:00AM-10:00PM (星期一至星期日)"
      }
    ],
    "phone": "",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 10,
    "name": "百老匯-豉油街店",
    "category": "百老匯",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.174467,
      22.314251
    ],
    "address": "豉油街28號地下",
    "date": [
      {
        "label": "时间",
        "name": "11:00AM-10:00PM (星期一至星期日)"
      }
    ],
    "phone": "",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 11,
    "name": "百老匯-西洋菜南街店",
    "category": "百老匯",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.174965,
      22.31625
    ],
    "address": "西洋菜南街80號地下至三樓",
    "date": [
      {
        "label": "时间",
        "name": "11:00AM-10:00PM (星期一至星期日)"
      }
    ],
    "phone": "",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 12,
    "name": "百老匯-海港城店",
    "category": "百老匯",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.173578,
      22.294757
    ],
    "address": "海港城海洋中心三階341號舖",
    "date": [
      {
        "label": "时间",
        "name": "11:00AM-10:00PM (星期一至星期日)"
      }
    ],
    "phone": "",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 13,
    "name": "百老匯-屯門市廣場店",
    "category": "百老匯",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      113.982199,
      22.39002
    ],
    "address": "屯門市廣場第一期地下G17號舖",
    "date": [
      {
        "label": "时间",
        "name": "11:00AM-10:00PM (星期一至星期日)"
      }
    ],
    "phone": "",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 14,
    "name": "百老匯-新城市廣場店",
    "category": "百老匯",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.19323,
      22.379154
    ],
    "address": "沙田新城市廣場第一期6樓612-613號舖",
    "date": [
      {
        "label": "时间",
        "name": "11:00AM-10:00PM (星期一至星期日)"
      }
    ],
    "phone": "",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 15,
    "name": "百老匯-創紀之城APM店",
    "category": "百老匯",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.229886,
      22.309705
    ],
    "address": "觀塘創紀之城第五期APM五樓Xsite2",
    "date": [
      {
        "label": "时间",
        "name": "11:00AM-10:00PM (星期一至星期日)"
      }
    ],
    "phone": "",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 16,
    "name": "百老匯-德福廣場店",
    "category": "百老匯",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.217639,
      22.320216
    ],
    "address": "九龍灣德福廣場第一期G22&G24號舖",
    "date": [
      {
        "label": "时间",
        "name": "11:00AM-10:00PM (星期一至星期日)"
      }
    ],
    "phone": "",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 17,
    "name": "百老匯-樂成大廈店",
    "category": "百老匯",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.032054,
      22.440212
    ],
    "address": "元朗教育路16號樂成大廈A-C及D7舖地下至三樓",
    "date": [
      {
        "label": "时间",
        "name": "11:00AM-10:00PM (星期一至星期日)"
      }
    ],
    "phone": "",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 18,
    "name": "百老匯-上水新都廣場店",
    "category": "百老匯",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.134278,
      22.499457
    ],
    "address": "上水新都廣場2樓211號舖",
    "date": [
      {
        "label": "时间",
        "name": "10:45AM-09:30PM (星期一至星期日)"
      }
    ],
    "phone": "",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 19,
    "name": "百老匯-太古城中心店",
    "category": "百老匯",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.222627,
      22.283009
    ],
    "address": "太古太古城中心4樓410號舖",
    "date": [
      {
        "label": "时间",
        "name": "11:00AM-10:00PM (星期一至星期日)"
      }
    ],
    "phone": "",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 20,
    "name": "百老匯-眾安街店",
    "category": "百老匯",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.121991,
      22.367319
    ],
    "address": "荃灣眾安街43號地下至二樓",
    "date": [
      {
        "label": "时间",
        "name": "11:00AM-10:00PM (星期一至星期日)"
      }
    ],
    "phone": "",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 21,
    "name": "友和-恒隆中心店",
    "category": "友和",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.19087,
      22.277439
    ],
    "address": "香港銅鑼灣百德新街2-20號恆隆中心9樓全層",
    "date": [
      {
        "label": "时间",
        "name": "12:00PM-8:00PM (星期一至星期日)"
      }
    ],
    "phone": "",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 22,
    "name": "J select-尖沙咀店",
    "category": "J select",
    "storetxt": "本店支持產品體驗一歡迎到店试用Ulike系列產品",
    "canExperience": true,
    "location": [
      114.179432,
      22.291827
    ],
    "address": "尖沙咀梳士巴利道18號K11 MUSEA B223A",
    "date": [
      {
        "label": "时间",
        "name": "11:00AM-9:00PM (星期一至星期四) 11:00AM-10:00PM (星期五至星期日)"
      }
    ],
    "phone": "",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 23,
    "name": "J select-將軍澳店",
    "category": "J select",
    "storetxt": "本店支持產品體驗一歡迎到店试用Ulike系列產品",
    "canExperience": true,
    "location": [
      114.264534,
      22.305087
    ],
    "address": "新界將軍澳唐賢街9號 PopCorn L1 F57-58舖",
    "date": [
      {
        "label": "时间",
        "name": "11:30AM-8:30PM (星期一至星期四) 11:30AM-9:30PM (星期五至星期日)"
      }
    ],
    "phone": "",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 24,
    "name": "J select-朗豪坊店",
    "category": "J select",
    "storetxt": "本店支持產品體驗一歡迎到店试用Ulike系列產品",
    "canExperience": true,
    "location": [
      114.173061,
      22.315404
    ],
    "address": "朗豪坊Langham Beauty 2樓D10舖",
    "date": [
      {
        "label": "时间",
        "name": "10:30AM-10:00PM (星期一至星期日及公眾假期)"
      }
    ],
    "phone": "",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 25,
    "name": "衛訊-新城市廣場店",
    "category": "衛訊",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.19323,
      22.379154
    ],
    "address": "新界沙田新城市廣場1期6樓615B號舖",
    "date": [
      {
        "label": "时间",
        "name": "11:00am - 9:00pm (星期一至星期日)"
      }
    ],
    "phone": "2771 1781",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 26,
    "name": "衛訊-Pop Corn店",
    "category": "衛訊",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.266344,
      22.305687
    ],
    "address": "新界將軍澳唐俊街9號Pop Corn 1樓F72號舖",
    "date": [
      {
        "label": "时间",
        "name": "11:00am - 9:00pm (星期一至星期日)"
      }
    ],
    "phone": "2752 1188",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 27,
    "name": "衛訊-上水新都廣場店",
    "category": "衛訊",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.134278,
      22.499457
    ],
    "address": "新界上水新都廣場2樓202-207B號舖",
    "date": [
      {
        "label": "时间",
        "name": "10:30am - 8:30pm (星期一至星期日)"
      }
    ],
    "phone": "2261 2568",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 28,
    "name": "衛訊-屯門市廣場店",
    "category": "衛訊",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      113.982199,
      22.39002
    ],
    "address": "新界屯門市廣場一期地下G123及G125號舖",
    "date": [
      {
        "label": "时间",
        "name": "11:00am - 9:00pm (星期一至星期日)"
      }
    ],
    "phone": "3580 2797",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 29,
    "name": "衛訊-百寶利商業中心店",
    "category": "衛訊",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.175244,
      22.31336
    ],
    "address": "九龍旺角西洋菜南街1A百寶利商業中心地下13、14及15號舖",
    "date": [
      {
        "label": "时间",
        "name": "11:30am - 9:30pm (星期一至星期日)"
      }
    ],
    "phone": "2388 0444",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 30,
    "name": "衛訊-始創中心店",
    "category": "衛訊",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.174018,
      22.319861
    ],
    "address": "九龍旺角彌敦道750號始創中心地下G09, G10及G24號舖",
    "date": [
      {
        "label": "时间",
        "name": "11:00am - 9:00pm (星期一至星期日)"
      }
    ],
    "phone": "2758 8300",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 31,
    "name": "蘇寧-新城市廣場店",
    "category": "蘇寧",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.19323,
      22.379154
    ],
    "address": "沙田沙田正街2-8號新城市廣場1期6樓610-611號舖",
    "date": [
      {
        "label": "时间",
        "name": "11:00am - 9:00pm (星期一至星期日)"
      }
    ],
    "phone": "2696 9616",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 32,
    "name": "蘇寧-荃灣廣場店",
    "category": "蘇寧",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.116489,
      22.367883
    ],
    "address": "新界荃灣廣場455-457號舖",
    "date": [
      {
        "label": "时间",
        "name": "11:00am - 9:00pm (星期一至星期日)"
      }
    ],
    "phone": "2147 0422",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 33,
    "name": "蘇寧-新都會廣場店",
    "category": "蘇寧",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.131075,
      22.354813
    ],
    "address": "葵芳興芳路223號新都會廣場5樓570-571號舖",
    "date": [
      {
        "label": "时间",
        "name": "11:00AM-8:00PM (星期一至星期五) 11:00AM-9:00PM (星期六至星期日)"
      }
    ],
    "phone": "2359 0300",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 34,
    "name": "蘇寧-東港城店",
    "category": "蘇寧",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.269964,
      22.313517
    ],
    "address": "將軍澳重華路8號東港城商場2樓258號舖",
    "date": [
      {
        "label": "时间",
        "name": "11:00am - 9:00pm (星期一至星期日)"
      }
    ],
    "phone": "2703 9929",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 35,
    "name": "AEON Style-康怡廣場店",
    "category": "AEON Style",
    "storetxt": "本店支持產品體驗一歡迎到店试用Ulike系列產品",
    "canExperience": true,
    "location": [
      114.22125,
      22.281211
    ],
    "address": "鰂魚涌康山道2號康怡廣場(南) 1樓",
    "date": [
      {
        "name": "10:00AM - 22:30PM (星期一至星期日)",
        "label": "时间"
      }
    ],
    "phone": "2884 6888",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 36,
    "name": "千色Citistore-荃灣千色匯店",
    "category": "千色Citistore",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.12277,
      22.367939
    ],
    "address": "香港新界荃灣地段301號荃灣千色匯II",
    "date": [
      {
        "label": "时间",
        "name": "10:00am - 10:00pm (星期一至星期日及公眾假期)"
      }
    ],
    "phone": "",
    "whatsapp": "2384 0006",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 37,
    "name": "千色Citistore-元朗千色匯店",
    "category": "千色Citistore",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.033557,
      22.439916
    ],
    "address": "香港新界元朗教育路1號元朗千色匯三至四樓",
    "date": [
      {
        "label": "时间",
        "name": "10:30AM-9:00PM (星期一至星期五) 10:00AM-9:30PM (星期六至星期日及公眾假期)"
      }
    ],
    "phone": "",
    "whatsapp": "2384 0006",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 38,
    "name": "千色Citistore-新港城中心店",
    "category": "千色Citistore",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.236933,
      22.421542
    ],
    "address": "香港新界沙田馬鞍山鞍祿街18號新港城中心三樓",
    "date": [
      {
        "label": "时间",
        "name": "10:30AM-9:30PM (星期一至星期五) 10:00AM-10:00PM (星期六至星期日及公眾假期)"
      }
    ],
    "phone": "",
    "whatsapp": "2384 0006",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 39,
    "name": "千色Citistore-MCP Central店",
    "category": "千色Citistore",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.262805,
      22.320253
    ],
    "address": "香港新界將軍澳MCP Central二樓（新都城中心二期）",
    "date": [
      {
        "label": "时间",
        "name": "10:30AM-9:30PM (星期一至星期五) 10:00AM-10:00PM (星期六至星期日及公眾假期)"
      }
    ],
    "phone": "",
    "whatsapp": "2384 0006",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 40,
    "name": "千色Citistore-屯門時代廣場店",
    "category": "千色Citistore",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      113.980926,
      22.389967
    ],
    "address": "香港新界屯門時代廣場北翼三樓",
    "date": [
      {
        "label": "时间",
        "name": "10:30AM-9:30PM (星期一至星期五) 10:00AM-10:00PM (星期六至星期日及公眾假期)"
      }
    ],
    "phone": "",
    "whatsapp": "2384 0006",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 41,
    "name": "APITA-太古城店",
    "category": "其他",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.222627,
      22.283009
    ],
    "address": "香港鰂魚涌太古城路77號太古城中心二期地下及地庫",
    "date": [
      {
        "label": "时间",
        "name": "10:00AM-10:00PM (星期一至星期日)"
      }
    ],
    "phone": "2885 0331",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 42,
    "name": "UNY-樂富廣場店",
    "category": "其他",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.19212,
      22.334614
    ],
    "address": "九龍橫頭磡樂富廣場2層",
    "date": [
      {
        "label": "时间",
        "name": "10:00AM-10:00PM (星期一至星期日)"
      }
    ],
    "phone": "2337 1663",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 43,
    "name": "MoBo Plus-始創中心店",
    "category": "其他",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.174018,
      22.319861
    ],
    "address": "九龍彌敦道750號始創中心2樓266號舖",
    "date": [
      {
        "label": "时间",
        "name": "11:00AM-8:00PM (星期一至星期日)"
      }
    ],
    "phone": "",
    "whatsapp": "9449 9955",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 44,
    "name": "KT Cool-觀塘廣場店",
    "category": "其他",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.230875,
      22.308365
    ],
    "address": "九龍觀塘開源道68號觀塘廣場2樓242號舖",
    "date": [
      {
        "label": "时间",
        "name": "12:00PM-8:30PM (星期一至星期日)"
      }
    ],
    "phone": "6402 6025",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 45,
    "name": "Green Mac-灣仔電腦城店",
    "category": "其他",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.177965,
      22.274544
    ],
    "address": "香港灣仔軒尼詩道130號灣仔電腦城2樓265-266號舖",
    "date": [
      {
        "label": "时间",
        "name": "12:00PM-8:00PM (星期一至星期日)"
      }
    ],
    "phone": "5121 3434",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 46,
    "name": "Uni Store-銅鑼灣地帶店",
    "category": "其他",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.190451,
      22.27774
    ],
    "address": "銅鑼灣記利佐治街2號銅鑼灣地帶2樓271號舖",
    "date": [
      {
        "label": "时间",
        "name": "12:00PM-9:15PM (星期一至星期日)"
      }
    ],
    "phone": "5305 4343",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 47,
    "name": "Gear Digital-始創中心店",
    "category": "其他",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.174018,
      22.319861
    ],
    "address": "九龍彌敦道750號始創中心2樓213A-B",
    "date": [
      {
        "label": "时间",
        "name": "12:00PM-9:00PM (星期一至星期日)"
      }
    ],
    "phone": "5305 4343",
    "whatsapp": "9588 0174",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 48,
    "name": "CWB Hot Spot-恒隆中心店",
    "category": "其他",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.19087,
      22.277439
    ],
    "address": "銅鑼灣百德新街2-20號恆隆中心7樓709室",
    "date": [
      {
        "label": "时间",
        "name": "11:30AM-8:30PM (星期一至星期日)"
      }
    ],
    "phone": "9390 4347",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  },
  {
    "id": 49,
    "name": "MW Beauty-駱駝漆店",
    "category": "其他",
    "storetxt": "本店在售Ulike系列產品，歡迎到店選購。",
    "canExperience": false,
    "location": [
      114.230136,
      22.307466
    ],
    "address": "觀塘開源道駱駝漆三座4樓M1室",
    "date": [
      {
        "label": "时间",
        "name": "11:00AM-8:00PM (星期一至星期日)"
      }
    ],
    "phone": "9681 5335",
    "whatsapp": "",
    "products": [
      {
        "name": "Air 10",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-air10.png?v=1784776596"
      },
      {
        "name": "Swift 7",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-swift7.png?v=1784776596"
      },
      {
        "name": "白皇后",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-baihuanghou.png?v=1784776596"
      },
      {
        "name": "超光炮Pro",
        "image": "https://cdn.shopify.com/s/files/1/0631/5966/4808/files/map-chaoguangpao_pro.png?v=1784776596"
      }
    ]
  }
];

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMap);
  } else {
    initMap();
  }
    function initMap() {
      map = new AMap.Map('map', {
        zoom: 13,
        center: userLocation,
        resizeEnable: true,
        lang: 'en',
        scrollWheel: false
      });

      infoWindow = new AMap.InfoWindow({
        offset: new AMap.Pixel(0, -40),
        autoPan: false
      });

      AMap.plugin(['AMap.Autocomplete', 'AMap.Geolocation'], function () {
        const auto = new AMap.Autocomplete({
          input: "search-input",
        });

        auto.on("select", function (e) {
              document.querySelector(".current-pos-tip").textContent = "";
          console.log("select-------------------", e);
          if (e.poi && e.poi.location) {
            userLocation = [e.poi.location.lng, e.poi.location.lat];
            renderStoreLocator();
          }
        });

        // const geolocation = new AMap.Geolocation({
        //   enableHighAccuracy: true,
        //   timeout: 5000,
        //   buttonPosition: 'RB',
        //   zoomToAccuracy: false
        // });


        const geolocation = new AMap.Geolocation({
        enableHighAccuracy: false,
        timeout: 15000,
        maximumAge: 60000,
        convert: true,
        showButton: false,
        showMarker: false,
        showCircle: false,
        panToLocation: false,
        zoomToAccuracy: false
        });



        map.addControl(geolocation);

        // 绑定"我的位置"按钮点击事件
const locateBtn = document.getElementById('locate-btn');
const locationTip = document.querySelector('.current-pos-tip');

if (locateBtn) {
  locateBtn.addEventListener('click', () => {
    if (locateBtn.disabled) return;

    locateBtn.disabled = true;
    locateBtn.classList.add('is-loading');
    locateBtn.textContent = '定位中...';

    if (locationTip) {
      locationTip.textContent = '';
    }

    showUserCenterMarker = false;

    if (infoWindow) {
      infoWindow.close();
    }

    if (userCenterMarker) {
      map.remove(userCenterMarker);
      userCenterMarker = null;
    }

    geolocation.getCurrentPosition((status, result) => {
      console.log('定位结果：', status, result);

      const lng = Number(result?.position?.lng);
      const lat = Number(result?.position?.lat);

      const isSuccess =
        status === 'complete' &&
        Number.isFinite(lng) &&
        Number.isFinite(lat);

      if (isSuccess) {
        userLocation = [lng, lat];
        showUserCenterMarker = true;

        map.setZoomAndCenter(15, userLocation);

        if (locationTip) {
          locationTip.textContent = '';
        }
      } else {
        showUserCenterMarker = false;

        // 注意这里必须是三个点
        userLocation = [...defaultLocation];

        let message = '暂时无法获取当前位置，请稍后重试';

        const errorCode = result?.code;
        const errorInfo = result?.info || result?.message || '';

        if (
          errorCode === 1 ||
          /permission|denied/i.test(errorInfo)
        ) {
          message = '请在浏览器设置中允许网站获取位置';
        } else if (
          errorCode === 3 ||
          /timeout/i.test(errorInfo)
        ) {
          message = '定位超时，请打开 Wi-Fi 后重试';
        } else if (
          errorCode === 2 ||
          /unavailable|unknown/i.test(errorInfo)
        ) {
          message = '当前定位服务不可用，请打开 Wi-Fi 后重试';
        }

        if (locationTip) {
          locationTip.textContent = message;
        }

        console.warn('当前位置定位失败：', {
          status,
          code: errorCode,
          info: errorInfo,
          result
        });
      }

      const searchInput = document.getElementById('search-input');

      if (searchInput) {
        searchInput.value = '';
      }

      activeCategory = '全部';

      renderStoreLocator();

      locateBtn.disabled = false;
      locateBtn.classList.remove('is-loading');
      locateBtn.textContent = '我的位置';
    });
  });
}


        // 首次加载渲染一次
        renderStoreLocator();
      });
    }

    // 根据传入的范围内门店，动态渲染筛选胶囊
    function renderFilterPills(storesWithinDistance) {
      const container = document.getElementById("filter-pills");
      if (!container) return; // 容错处理
      container.innerHTML = "";

      // 统计当前范围内的各类目数量
      const categoryCounts = {};
      storesWithinDistance.forEach(store => {
        categoryCounts[store.category] = (categoryCounts[store.category] || 0) + 1;
      });

      // 创建 "全部" 按钮
      const allPill = document.createElement("div");
      allPill.className = `filter-pill ${activeCategory === '全部' ? 'active' : ''}`;
      allPill.textContent = "全部";
      allPill.onclick = () => updateCategory('全部');
      container.appendChild(allPill);

      // 遍历渲染其他分类按钮
      for (const [cat, count] of Object.entries(categoryCounts)) {
        const pill = document.createElement("div");
        pill.className = `filter-pill ${activeCategory === cat ? 'active' : ''}`;
        pill.textContent = `${cat}(${count})`;
        pill.onclick = () => updateCategory(cat);
        container.appendChild(pill);
      }
    }

    // 更新选中分类并重新渲染
    function updateCategory(cat) {
      activeCategory = cat;
      renderStoreLocator();    // 更新地图和列表
      
      // 点击分类时关闭 Info 弹窗
      if (infoWindow) {
        infoWindow.close();
      }
    }


    function clearAllFilters() {
      // 清空输入框
      const searchInput = document.getElementById("search-input");
      if (searchInput) {
        searchInput.value = "";
      }
      
      // 恢复为默认位置
      userLocation = [...defaultLocation];
      showUserCenterMarker = false;
      
      // 移除用户中心点标记
      if (userCenterMarker) {
        map.remove(userCenterMarker);
        userCenterMarker = null;
      }
      
      // 恢复地图中心点
      map.setCenter(userLocation);
      
      // 重置分类到“全部”
      updateCategory('全部');
    }

    // 绑定 "清除全部篩選"
    const clearBtn = document.getElementById("clear-filters-btn");
    if (clearBtn) {
        clearBtn.addEventListener("click", clearAllFilters);
    }
    document.body.addEventListener("click", (event) => {
      console.log('event---------', event);
      
      if (event.target.matches('.no-store-txt-link') || event.target.closest('.no-store-txt-link')) {
        event.preventDefault(); 
        clearAllFilters(); 
      }
    });


function injectRealisticPersonMarkerStyles() {
  if (document.getElementById("realistic-person-marker-style")) {
    return;
  }

  const style = document.createElement("style");

  style.id = "realistic-person-marker-style";

  style.textContent = `
    /*
     * 高德地图实际定位的最外层容器。
     * 不要在这里添加 transform 或 animation。
     */
    .realistic-person-marker {
      position: relative;
      width: 88px;
      height: 104px;
      overflow: visible;
      pointer-events: none;
      user-select: none;
    }

    .realistic-person-marker svg {
      display: block;
      width: 88px;
      height: 104px;
      overflow: visible;
    }

    /* 人物整体悬浮 */
    .rpm-character {
      transform-box: view-box;
      transform-origin: 44px 90px;
      animation: rpm-character-float 2.1s ease-in-out infinite;
      will-change: transform;
    }

    /* 背景光环 */
    .rpm-halo {
      transform-box: fill-box;
      transform-origin: center;
      animation: rpm-halo-breathe 2.2s ease-in-out infinite;
    }

    /* 外部装饰圆环 */
    .rpm-orbit-ring {
      transform-box: fill-box;
      transform-origin: center;
      animation: rpm-orbit-rotate 7s linear infinite;
    }

    /* 右手挥手 */
    .rpm-right-arm {
      transform-box: view-box;
      transform-origin: 58px 51px;
      animation: rpm-wave-arm 1.35s ease-in-out infinite;
      will-change: transform;
    }

    /* 右手手掌轻微摆动 */
    .rpm-right-hand {
      transform-box: fill-box;
      transform-origin: center bottom;
      animation: rpm-wave-hand 1.35s ease-in-out infinite;
    }

    /* 左手轻微摆动 */
    .rpm-left-arm {
      transform-box: view-box;
      transform-origin: 30px 51px;
      animation: rpm-left-arm-move 2.1s ease-in-out infinite;
    }

    /* 双腿交替运动 */
    .rpm-left-leg {
      transform-box: view-box;
      transform-origin: 38px 69px;
      animation: rpm-left-leg-move 2.1s ease-in-out infinite;
    }

    .rpm-right-leg {
      transform-box: view-box;
      transform-origin: 50px 69px;
      animation: rpm-right-leg-move 2.1s ease-in-out infinite;
    }

    /* 眨眼 */
    .rpm-eyes {
      transform-box: fill-box;
      transform-origin: center;
      animation: rpm-blink 4.5s infinite;
    }

    /* 衣服高光流动 */
    .rpm-clothes-shine {
      animation: rpm-shine-move 3.4s ease-in-out infinite;
    }

    /* 脚下阴影 */
    .rpm-shadow {
      transform-box: fill-box;
      transform-origin: center;
      animation: rpm-shadow-change 2.1s ease-in-out infinite;
    }

    /* 定位脉冲 */
    .rpm-pulse-one,
    .rpm-pulse-two {
      transform-box: fill-box;
      transform-origin: center;
    }

    .rpm-pulse-one {
      animation: rpm-location-pulse 2.5s ease-out infinite;
    }

    .rpm-pulse-two {
      animation: rpm-location-pulse 2.5s ease-out 1.25s infinite;
    }

    /* 地面中心点 */
    .rpm-ground-dot {
      transform-box: fill-box;
      transform-origin: center;
      animation: rpm-ground-dot-glow 1.6s ease-in-out infinite;
    }

    /* 胸前定位图标 */
    .rpm-chest-location {
      transform-box: fill-box;
      transform-origin: center;
      animation: rpm-chest-location-glow 1.8s ease-in-out infinite;
    }

    @keyframes rpm-character-float {
      0%,
      100% {
        transform: translateY(0) rotate(-0.4deg);
      }

      50% {
        transform: translateY(-5px) rotate(0.4deg);
      }
    }

    @keyframes rpm-halo-breathe {
      0%,
      100% {
        opacity: 0.55;
        transform: scale(0.92);
      }

      50% {
        opacity: 1;
        transform: scale(1.08);
      }
    }

    @keyframes rpm-orbit-rotate {
      from {
        transform: rotate(0deg);
      }

      to {
        transform: rotate(360deg);
      }
    }

    @keyframes rpm-wave-arm {
      0%,
      100% {
        transform: rotate(-4deg);
      }

      25% {
        transform: rotate(-18deg);
      }

      50% {
        transform: rotate(-7deg);
      }

      75% {
        transform: rotate(-22deg);
      }
    }

    @keyframes rpm-wave-hand {
      0%,
      100% {
        transform: rotate(0deg);
      }

      25% {
        transform: rotate(9deg);
      }

      50% {
        transform: rotate(-5deg);
      }

      75% {
        transform: rotate(8deg);
      }
    }

    @keyframes rpm-left-arm-move {
      0%,
      100% {
        transform: rotate(2deg);
      }

      50% {
        transform: rotate(-5deg);
      }
    }

    @keyframes rpm-left-leg-move {
      0%,
      100% {
        transform: rotate(2deg);
      }

      50% {
        transform: rotate(-4deg);
      }
    }

    @keyframes rpm-right-leg-move {
      0%,
      100% {
        transform: rotate(-2deg);
      }

      50% {
        transform: rotate(4deg);
      }
    }

    @keyframes rpm-blink {
      0%,
      43%,
      47%,
      79%,
      83%,
      100% {
        transform: scaleY(1);
      }

      45%,
      81% {
        transform: scaleY(0.08);
      }
    }

    @keyframes rpm-shadow-change {
      0%,
      100% {
        opacity: 0.34;
        transform: scaleX(1);
      }

      50% {
        opacity: 0.15;
        transform: scaleX(0.68);
      }
    }

    @keyframes rpm-location-pulse {
      0% {
        opacity: 0.85;
        transform: scale(0.35);
      }

      70% {
        opacity: 0.15;
      }

      100% {
        opacity: 0;
        transform: scale(2.25);
      }
    }

    @keyframes rpm-ground-dot-glow {
      0%,
      100% {
        opacity: 1;
        transform: scale(1);
      }

      50% {
        opacity: 0.75;
        transform: scale(0.78);
      }
    }

    @keyframes rpm-chest-location-glow {
      0%,
      100% {
        filter: drop-shadow(0 0 2px rgba(255, 255, 255, 0.4));
      }

      50% {
        filter: drop-shadow(0 0 6px rgba(255, 255, 255, 1));
      }
    }

    @keyframes rpm-shine-move {
      0%,
      25% {
        transform: translateX(-24px) skewX(-14deg);
        opacity: 0;
      }

      40% {
        opacity: 0.65;
      }

      58% {
        transform: translateX(34px) skewX(-14deg);
        opacity: 0;
      }

      100% {
        transform: translateX(34px) skewX(-14deg);
        opacity: 0;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      .realistic-person-marker *,
      .realistic-person-marker *::before,
      .realistic-person-marker *::after {
        animation: none !important;
      }
    }
  `;

  document.head.appendChild(style);
}

function createRealisticPersonLocationMarker() {
  injectRealisticPersonMarkerStyles();

  const markerContent = document.createElement("div");
  const uid = `rpm-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;

  markerContent.className = "realistic-person-marker";

  markerContent.innerHTML = `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="88"
      height="104"
      viewBox="0 0 88 104"
      aria-hidden="true"
    >
      <defs>
        <!-- 肤色 -->
        <radialGradient id="${uid}-skin" cx="34%" cy="24%" r="78%">
          <stop offset="0%" stop-color="#fff7f0"/>
          <stop offset="22%" stop-color="#ffd9c1"/>
          <stop offset="70%" stop-color="#f6b58d"/>
          <stop offset="100%" stop-color="#df8e66"/>
        </radialGradient>

        <!-- 耳朵肤色 -->
        <linearGradient id="${uid}-ear" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="#ffd7be"/>
          <stop offset="100%" stop-color="#e99c72"/>
        </linearGradient>

        <!-- 头发 -->
        <linearGradient id="${uid}-hair" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="#536579"/>
          <stop offset="24%" stop-color="#293a4e"/>
          <stop offset="70%" stop-color="#132235"/>
          <stop offset="100%" stop-color="#081421"/>
        </linearGradient>

        <!-- 蓝色外套 -->
        <linearGradient id="${uid}-jacket" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="#8cd5ff"/>
          <stop offset="20%" stop-color="#4dadff"/>
          <stop offset="58%" stop-color="#167fee"/>
          <stop offset="100%" stop-color="#0646ad"/>
        </linearGradient>

        <!-- 外套暗部 -->
        <linearGradient id="${uid}-jacket-dark" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stop-color="#1b82e9"/>
          <stop offset="100%" stop-color="#073f9e"/>
        </linearGradient>

        <!-- 裤子 -->
        <linearGradient id="${uid}-pants" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="#344f79"/>
          <stop offset="52%" stop-color="#1d3558"/>
          <stop offset="100%" stop-color="#0b1f3e"/>
        </linearGradient>

        <!-- 鞋子 -->
        <linearGradient id="${uid}-shoe" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stop-color="#39485a"/>
          <stop offset="100%" stop-color="#101a27"/>
        </linearGradient>

        <!-- 光环 -->
        <radialGradient id="${uid}-halo">
          <stop offset="0%" stop-color="#64baff" stop-opacity="0.32"/>
          <stop offset="52%" stop-color="#238eff" stop-opacity="0.14"/>
          <stop offset="100%" stop-color="#238eff" stop-opacity="0"/>
        </radialGradient>

        <!-- 定位波纹 -->
        <radialGradient id="${uid}-pulse">
          <stop offset="0%" stop-color="#258fff" stop-opacity="0.22"/>
          <stop offset="60%" stop-color="#258fff" stop-opacity="0.08"/>
          <stop offset="100%" stop-color="#258fff" stop-opacity="0"/>
        </radialGradient>

        <!-- 衣服高光裁剪 -->
        <clipPath id="${uid}-body-clip">
          <path d="
            M29 48
            C32 44 37 42 44 42
            C51 42 56 44 59 48
            L62 67
            C58 71 53 73 44 73
            C35 73 30 71 26 67
            Z
          "/>
        </clipPath>

        <filter id="${uid}-soft-shadow" x="-60%" y="-60%" width="220%" height="220%">
          <feGaussianBlur stdDeviation="2.8"/>
        </filter>

        <filter id="${uid}-person-shadow" x="-60%" y="-60%" width="220%" height="220%">
          <feDropShadow
            dx="0"
            dy="4"
            stdDeviation="3"
            flood-color="#07458e"
            flood-opacity="0.32"
          />
        </filter>

        <filter id="${uid}-blue-glow" x="-80%" y="-80%" width="260%" height="260%">
          <feGaussianBlur stdDeviation="2.2" result="blur"/>
          <feMerge>
            <feMergeNode in="blur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>

      <!-- 地面波纹，定位坐标为 44,92 -->
      <g>
        <ellipse
          class="rpm-pulse-one"
          cx="44"
          cy="92"
          rx="19"
          ry="7"
          fill="url(#${uid}-pulse)"
          stroke="#3b9cff"
          stroke-width="1"
        />

        <ellipse
          class="rpm-pulse-two"
          cx="44"
          cy="92"
          rx="19"
          ry="7"
          fill="url(#${uid}-pulse)"
          stroke="#3b9cff"
          stroke-width="1"
        />

        <ellipse
          class="rpm-shadow"
          cx="44"
          cy="91"
          rx="17"
          ry="5"
          fill="#062e65"
          opacity="0.3"
          filter="url(#${uid}-soft-shadow)"
        />

        <ellipse
          cx="44"
          cy="92"
          rx="12"
          ry="4"
          fill="none"
          stroke="#56aeff"
          stroke-width="0.8"
          stroke-opacity="0.55"
        />

        <circle
          class="rpm-ground-dot"
          cx="44"
          cy="92"
          r="3.4"
          fill="#258fff"
          stroke="#ffffff"
          stroke-width="1.8"
          filter="url(#${uid}-blue-glow)"
        />
      </g>

      <!-- 人物 -->
      <g class="rpm-character" filter="url(#${uid}-person-shadow)">
        <!-- 背景光环 -->
        <circle
          class="rpm-halo"
          cx="44"
          cy="44"
          r="34"
          fill="url(#${uid}-halo)"
        />

        <!-- 装饰圆环 -->
        <g class="rpm-orbit-ring" opacity="0.72">
          <circle
            cx="44"
            cy="44"
            r="29"
            fill="none"
            stroke="#72c4ff"
            stroke-width="0.8"
            stroke-dasharray="3 5"
          />

          <circle
            cx="44"
            cy="15"
            r="2"
            fill="#ffffff"
            filter="url(#${uid}-blue-glow)"
          />
        </g>

        <!-- 左手，放在身体后方 -->
        <g class="rpm-left-arm">
          <path
            d="M30 51 C24 54 23 62 25 69"
            fill="none"
            stroke="url(#${uid}-jacket-dark)"
            stroke-width="9"
            stroke-linecap="round"
          />

          <circle
            cx="25"
            cy="70"
            r="4.5"
            fill="url(#${uid}-skin)"
            stroke="#ffffff"
            stroke-width="1"
          />
        </g>

        <!-- 双腿 -->
        <g class="rpm-left-leg">
          <path
            d="M38 69 L37 85"
            fill="none"
            stroke="url(#${uid}-pants)"
            stroke-width="9"
            stroke-linecap="round"
          />

          <path
            d="M32.5 84.5 C36 82.5 40 82.8 42 86 L41 89 L31 89 C30 87 30.8 85.5 32.5 84.5Z"
            fill="url(#${uid}-shoe)"
            stroke="#ffffff"
            stroke-opacity="0.65"
            stroke-width="0.8"
          />

          <path
            d="M32 87.5 L41 87.5"
            stroke="#8da2b7"
            stroke-width="0.7"
            stroke-linecap="round"
          />
        </g>

        <g class="rpm-right-leg">
          <path
            d="M50 69 L51 85"
            fill="none"
            stroke="url(#${uid}-pants)"
            stroke-width="9"
            stroke-linecap="round"
          />

          <path
            d="M47 85 C50 82.7 54 82.7 57 85 L58 89 L47 89 C46 87.5 46 86 47 85Z"
            fill="url(#${uid}-shoe)"
            stroke="#ffffff"
            stroke-opacity="0.65"
            stroke-width="0.8"
          />

          <path
            d="M48 87.5 L57 87.5"
            stroke="#8da2b7"
            stroke-width="0.7"
            stroke-linecap="round"
          />
        </g>

        <!-- 颈部 -->
        <path
          d="M39 39 L39 46 C41 48 47 48 49 46 L49 39Z"
          fill="url(#${uid}-skin)"
        />

        <!-- 身体 -->
        <path
          d="
            M29 48
            C32 44 37 42 44 42
            C51 42 56 44 59 48
            L62 67
            C58 71 53 73 44 73
            C35 73 30 71 26 67
            Z
          "
          fill="url(#${uid}-jacket)"
          stroke="#ffffff"
          stroke-width="1.4"
          stroke-linejoin="round"
        />

        <!-- 肩部阴影 -->
        <path
          d="M29 49 C34 52 37 53 44 53 C51 53 55 51 59 48"
          fill="none"
          stroke="#ffffff"
          stroke-opacity="0.18"
          stroke-width="2"
        />

        <!-- 衣服流动高光 -->
        <g clip-path="url(#${uid}-body-clip)">
          <rect
            class="rpm-clothes-shine"
            x="18"
            y="39"
            width="9"
            height="42"
            rx="5"
            fill="#ffffff"
            opacity="0"
          />
        </g>

        <!-- 拉链 -->
        <path
          d="M44 49 L44 70"
          stroke="#d8efff"
          stroke-width="1"
          stroke-opacity="0.75"
        />

        <circle cx="44" cy="54" r="1" fill="#ffffff" opacity="0.8"/>
        <circle cx="44" cy="61" r="1" fill="#ffffff" opacity="0.8"/>

        <!-- 胸前定位标识 -->
        <g class="rpm-chest-location">
          <path
            d="
              M44 55
              C40.8 55 38.5 57.3 38.5 60.2
              C38.5 64 44 68 44 68
              C44 68 49.5 64 49.5 60.2
              C49.5 57.3 47.2 55 44 55Z
            "
            fill="#ffffff"
            opacity="0.96"
          />

          <circle cx="44" cy="60.2" r="2" fill="#258fff"/>
        </g>

        <!-- 右手挥手 -->
        <g class="rpm-right-arm">
          <path
            d="M58 51 C64 48 67 42 69 36"
            fill="none"
            stroke="url(#${uid}-jacket)"
            stroke-width="9"
            stroke-linecap="round"
          />

          <!-- 袖口 -->
          <path
            d="M66.5 38.5 L71 40"
            stroke="#d9efff"
            stroke-width="2"
            stroke-linecap="round"
          />

          <g class="rpm-right-hand">
            <ellipse
              cx="70.5"
              cy="32.5"
              rx="5"
              ry="6"
              fill="url(#${uid}-skin)"
              stroke="#ffffff"
              stroke-width="1"
            />

            <!-- 手指 -->
            <path
              d="M68 29 L66.5 24.5"
              stroke="#f4b087"
              stroke-width="2.1"
              stroke-linecap="round"
            />

            <path
              d="M70 28 L69.5 23.3"
              stroke="#f4b087"
              stroke-width="2.1"
              stroke-linecap="round"
            />

            <path
              d="M72 28.5 L73 24"
              stroke="#f4b087"
              stroke-width="2"
              stroke-linecap="round"
            />

            <path
              d="M73.5 30 L76 27"
              stroke="#f4b087"
              stroke-width="1.9"
              stroke-linecap="round"
            />
          </g>
        </g>

        <!-- 耳朵 -->
        <ellipse
          cx="29.5"
          cy="29"
          rx="4"
          ry="5.5"
          fill="url(#${uid}-ear)"
          stroke="#ffffff"
          stroke-opacity="0.7"
          stroke-width="0.8"
        />

        <ellipse
          cx="58.5"
          cy="29"
          rx="4"
          ry="5.5"
          fill="url(#${uid}-ear)"
          stroke="#ffffff"
          stroke-opacity="0.7"
          stroke-width="0.8"
        />

        <!-- 脸 -->
        <path
          d="
            M30 26
            C30 16 35.5 10 44 10
            C52.5 10 58 16 58 26
            L57 32
            C56 39 51 44 44 44
            C37 44 32 39 31 32
            Z
          "
          fill="url(#${uid}-skin)"
          stroke="#ffffff"
          stroke-width="1.3"
        />

        <!-- 脸部侧面阴影 -->
        <path
          d="
            M53 16
            C57 20 57.5 26 56.5 32
            C55.5 37 52.5 40 48.5 42
            C52 38 53.5 34 53.7 28
            C54 23 53.5 19 53 16Z
          "
          fill="#c97555"
          opacity="0.1"
        />

        <!-- 头发主体 -->
        <path
          d="
            M29.5 26
            C28.5 18 32 10 39 7
            C46 4 54 7 58.5 14
            C61 18 60 23 58 27
            C56.5 23 54.5 20 52 17
            C48 20 43 21 37.5 19
            C35 22 32.5 24 29.5 26Z
          "
          fill="url(#${uid}-hair)"
        />

        <!-- 头发高光 -->
        <path
          d="M36 11 C42 7.5 49 8 53.5 12"
          fill="none"
          stroke="#8291a1"
          stroke-width="2"
          stroke-linecap="round"
          opacity="0.45"
        />

        <path
          d="M32 19 C35 16 37 13 39 9"
          fill="none"
          stroke="#8998a8"
          stroke-width="1.3"
          stroke-linecap="round"
          opacity="0.35"
        />

        <!-- 眉毛 -->
        <path
          d="M35 27 C37 25.8 39 25.8 41 26.7"
          fill="none"
          stroke="#5c463f"
          stroke-width="1.3"
          stroke-linecap="round"
        />

        <path
          d="M47 26.7 C49 25.8 51 25.8 53 27"
          fill="none"
          stroke="#5c463f"
          stroke-width="1.3"
          stroke-linecap="round"
        />

        <!-- 眼睛 -->
        <g class="rpm-eyes">
          <ellipse cx="38.2" cy="30" rx="1.7" ry="2.1" fill="#253346"/>
          <ellipse cx="49.8" cy="30" rx="1.7" ry="2.1" fill="#253346"/>

          <circle cx="37.7" cy="29.4" r="0.5" fill="#ffffff"/>
          <circle cx="49.3" cy="29.4" r="0.5" fill="#ffffff"/>
        </g>

        <!-- 鼻子 -->
        <path
          d="M44 30.5 C43.5 32.5 43.4 33.5 45 34"
          fill="none"
          stroke="#d68567"
          stroke-width="1"
          stroke-linecap="round"
        />

        <!-- 腮红 -->
        <ellipse cx="34.5" cy="34.2" rx="3.2" ry="1.5" fill="#ee7f7f" opacity="0.2"/>
        <ellipse cx="53.5" cy="34.2" rx="3.2" ry="1.5" fill="#ee7f7f" opacity="0.2"/>

        <!-- 嘴巴 -->
        <path
          d="M40.5 36.7 C42.3 38.5 45.7 38.5 47.5 36.7"
          fill="none"
          stroke="#a95555"
          stroke-width="1.3"
          stroke-linecap="round"
        />

        <path
          d="M42 37.7 C43 38.2 45 38.2 46 37.7"
          fill="none"
          stroke="#ffffff"
          stroke-width="0.7"
          stroke-linecap="round"
          opacity="0.85"
        />
      </g>
    </svg>
  `;

  return markerContent;
}

    // 核心渲染逻辑
    function renderStoreLocator() {
      // 1. 绘制定位中心
      if (userCenterMarker) {
        map.remove(userCenterMarker);
          userCenterMarker = null;
      }
if (showUserCenterMarker) {
  if (!userCenterMarker) {
    userCenterMarker = new AMap.Marker({
      position: userLocation,
      map: map,
      content: createRealisticPersonLocationMarker(),

      // 小人脚下定位点：x = 44，y = 92
      offset: new AMap.Pixel(-44, -92),

      zIndex: 999,
      clickable: false,
      bubble: false
    });
  } else {
    userCenterMarker.setPosition(userLocation);
  }
} else {
  // 定位失败或还未点击定位按钮时，不显示标记
  if (userCenterMarker) {
    map.remove(userCenterMarker);
    userCenterMarker = null;
  }
}

      // 2. 距离计算
      const maxDistanceLimit = 30000; // 30公里
      let storesWithDistance = storeDataset
        .map(store => {
          const distanceInMeters = AMap.GeometryUtil.distance(userLocation, store.location);
          return {
            ...store,
            distanceVal: distanceInMeters,
            distanceStr: (distanceInMeters / 1000).toFixed(2)
          };
        })
        .filter(store => store.distanceVal <= maxDistanceLimit);

      // 在通过分类过滤之前，渲染当前的分类胶囊
      renderFilterPills(storesWithDistance);

      // 3. 应用分类筛选
      if (activeCategory !== '全部') {
        storesWithDistance = storesWithDistance.filter(store => store.category === activeCategory);
      }

      // 按距离排序
      storesWithDistance.sort((a, b) => a.distanceVal - b.distanceVal);
      
      // 更新界面数量显示
      const countElement = document.getElementById('store-count-txt');
      if (countElement) {
          countElement.textContent = `共${storesWithDistance.length}家门店`;
      }

      const listContainer = document.getElementById("store-list");
      if (!listContainer) return;
      
      listContainer.innerHTML = "";
      if (markers.length > 0) {
        map.remove(markers);
        markers = [];
      }

      if (storesWithDistance.length === 0) {
        listContainer.innerHTML = `<div class="no-store-container">
          <div class="no-store-txt">暂无符合条件的门店</div>
           <a href="javascript:;" class="no-store-txt-link">展示所有门店</a>
          </div>`;
        return;
      }

      let activeMarkerContent = null;
      const DEFAULT_COLOR = "black";
      const ACTIVE_COLOR = "#E0004D";

      // 4. 遍历渲染过滤后的门店
      storesWithDistance.forEach((store, index) => {
        const markerContent = document.createElement('div');
        markerContent.className = 'custom-marker-container';
        markerContent.innerHTML = `
          <div style="position: absolute; width: 36px; height: 47px; left: 0px; top: 0px; transform: scale(1.0); transform-origin: 18px 47px;">
            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="47" viewBox="0 0 36 47" aria-hidden="true">
              <g clip-path="url(#clip0_8675_11227)">
                <path class="marker-bg" d="M31.4809 31.4819C29.156 34.9049 23.6056 41.8779 20.4015 45.8557C20.114 46.2127 19.7497 46.5009 19.3355 46.6989C18.9212 46.8969 18.4676 46.9997 18.0081 46.9997C17.5487 46.9997 17.095 46.8969 16.6808 46.6989C16.2665 46.5009 15.9022 46.2127 15.6148 45.8557C12.41 41.8779 6.85964 34.9049 4.53532 31.4819C-2.08628 21.7327 -1.18985 12.124 5.6409 5.32047C7.26339 3.70032 9.19129 2.41549 11.3138 1.53981C13.4363 0.664123 15.7116 0.214843 18.009 0.217788C20.3063 0.214856 22.5815 0.664143 24.7039 1.53983C26.8264 2.41551 28.7542 3.70033 30.3765 5.32047C37.2061 12.1246 38.1025 21.7327 31.4809 31.4819Z" fill="${DEFAULT_COLOR}"/>
                <path d="M20.5078 15.7719H21.7805V22.5076C21.7503 24.6688 19.9722 25.9796 18.0763 25.9796C16.1803 25.9796 14.4029 24.6688 14.3715 22.5076V14.1406H8.32812L9.48229 15.7719H10.7573V22.3901C10.7573 26.2558 14.5605 27.7985 18.0739 27.7873C21.5867 27.7985 25.3899 26.2528 25.3899 22.3901V14.1406H19.3537L20.5078 15.7719Z" fill="white"/>
              </g>
              <defs>
                <clipPath id="clip0_8675_11227"><rect width="36" height="47" fill="white"/></clipPath>
              </defs>
            </svg>
          </div>
        `;

        const marker = new AMap.Marker({
          position: store.location,
          map: map,
          title: store.name,
          animation: "AMAP_ANIMATION_DROP",
          content: markerContent,
          offset: new AMap.Pixel(-18, -47)
        });

        markers.push(marker);


        const highlightMarker = () => {
          if (activeMarkerContent && activeMarkerContent !== markerContent) {
            const prevPath = activeMarkerContent.querySelector('.marker-bg');
            if (prevPath) prevPath.setAttribute('fill', DEFAULT_COLOR);
          }
          
          const currentPath = markerContent.querySelector('.marker-bg');
          if (currentPath) currentPath.setAttribute('fill', ACTIVE_COLOR);
          
          activeMarkerContent = markerContent;
        };


        marker.on("click", () => {
          highlightMarker();
          showInfoWindow(store, marker);
        });

        // 创建左侧列表 DOM
        const listItem = document.createElement("div");
        listItem.className = "store-item";
        listItem.innerHTML = `
          <h3>${store.name}</h3>
          <p>${store.address}</p>
          <span class="distance">${store.distanceStr} km</span>
        `;

        // 列表联动地图
        listItem.addEventListener("click", () => {
          highlightMarker();
          map.setZoomAndCenter(16, store.location);
          showInfoWindow(store, marker);

          if (window.innerWidth <= 768) {
            document.querySelector('.map-container').scrollIntoView({ behavior: 'smooth' });
          }
        });

        listContainer.appendChild(listItem);
      });

      // 自动适应全部标记点视野
      // if (markers.length > 0) {
      //   map.setFitView([userCenterMarker,...markers], false, [60, 60, 60, 60]);
      // }
if (markers.length > 0) {
  const fitViewMarkers =
    showUserCenterMarker && userCenterMarker
      ? [userCenterMarker, ...markers]
      : markers;

  map.setFitView(
    fitViewMarkers,
    false,
    [60, 60, 60, 60]
  );
}
    }

    // 显示信息窗体
    function showInfoWindow(store, marker) {
      let productsHtml = '';
      if (store.products && store.products.length > 0) {
        productsHtml = `
            <div class="info-window-products">
              <div class="info-window-products-tip ${!store.canExperience ? 'active':''}">${store.storetxt}</div>
                <h5 class="info-window-h5">在售產品</h5>
                <div class="product-list">
                    ${store.products.map(p => `
                        <div class="product-item">
                            <img src="${p.image}" alt="${p.name}" class="product-img">
                            <span class="product-name">${p.name}</span>
                        </div>
                    `).join('')}
                </div>
            </div>
        `;
      }


      let phoneHtml = '';
        if (store.phone) {
          phoneHtml = `<a class="info-window-btn info-window-btn2" href="tel:${store.phone}">致電門店</a>`;
        }
        if (store.whatsapp) {
          phoneHtml = `<a class="info-window-btn info-window-btn2" href="https://wa.me/${store.whatsapp}">致電門店</a>`;
        }

         let phoneHtmlSection = '';
        if (store.phone) {
          phoneHtmlSection = `<div class="info-window-li">
               <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M12 7C12 8.33553 11.4799 9.59124 10.5356 10.5356C9.59136 11.48 8.33577 12 7 12C5.66423 12 4.40888 11.4801 3.46451 10.5356C2.52015 9.59112 2 8.33577 2 7C2 5.66423 2.52015 4.40888 3.46451 3.46451C4.40888 2.52015 5.66435 2 7 2C8.33565 2 9.59124 2.52015 10.5356 3.46451C11.48 4.40888 12 5.66447 12 7Z" fill="#4D4D4D"/>
                <path d="M8.97689 8.34252L8.78914 8.69935C8.75363 8.76748 8.70122 8.82535 8.63694 8.86742C8.08346 9.22728 6.9806 8.83507 6.0728 7.9272C5.165 7.01933 4.77271 5.91657 5.13256 5.36309C5.17464 5.29881 5.23252 5.2464 5.30064 5.21089L5.65748 5.02315C5.69854 5.00157 5.74578 4.99481 5.79124 5.00399C5.8367 5.01318 5.87761 5.03775 5.90708 5.07357L6.46174 5.74454C6.49384 5.78325 6.51033 5.83255 6.50797 5.88278C6.5056 5.93301 6.48456 5.98055 6.44897 6.01607L6.23492 6.23012C6.21407 6.25087 6.20014 6.27756 6.19502 6.30653C6.18991 6.33549 6.19386 6.36534 6.20634 6.39198C6.27568 6.54014 6.44678 6.84814 6.79933 7.20077C7.15188 7.55339 7.45997 7.72441 7.60821 7.79374C7.63484 7.80624 7.66468 7.8102 7.69365 7.8051C7.72262 7.8 7.74931 7.78609 7.77007 7.76526L7.98412 7.55121C8.01964 7.51561 8.06718 7.49457 8.11741 7.49221C8.16765 7.48984 8.21695 7.50633 8.25566 7.53843L8.92655 8.09309C8.96232 8.12256 8.98685 8.16344 8.99601 8.20886C9.00518 8.25429 8.99843 8.30149 8.97689 8.34252Z" fill="white"/>
               </svg>
               <div class="info-window-li-txt">熱線電話：${store.phone}</div>
              </div>`;
        }
        if (store.whatsapp) {
          phoneHtmlSection = `<div class="info-window-li">
               <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M12 7C12 8.33553 11.4799 9.59124 10.5356 10.5356C9.59136 11.48 8.33577 12 7 12C5.66423 12 4.40888 11.4801 3.46451 10.5356C2.52015 9.59112 2 8.33577 2 7C2 5.66423 2.52015 4.40888 3.46451 3.46451C4.40888 2.52015 5.66435 2 7 2C8.33565 2 9.59124 2.52015 10.5356 3.46451C11.48 4.40888 12 5.66447 12 7Z" fill="#4D4D4D"/>
                <path d="M8.97689 8.34252L8.78914 8.69935C8.75363 8.76748 8.70122 8.82535 8.63694 8.86742C8.08346 9.22728 6.9806 8.83507 6.0728 7.9272C5.165 7.01933 4.77271 5.91657 5.13256 5.36309C5.17464 5.29881 5.23252 5.2464 5.30064 5.21089L5.65748 5.02315C5.69854 5.00157 5.74578 4.99481 5.79124 5.00399C5.8367 5.01318 5.87761 5.03775 5.90708 5.07357L6.46174 5.74454C6.49384 5.78325 6.51033 5.83255 6.50797 5.88278C6.5056 5.93301 6.48456 5.98055 6.44897 6.01607L6.23492 6.23012C6.21407 6.25087 6.20014 6.27756 6.19502 6.30653C6.18991 6.33549 6.19386 6.36534 6.20634 6.39198C6.27568 6.54014 6.44678 6.84814 6.79933 7.20077C7.15188 7.55339 7.45997 7.72441 7.60821 7.79374C7.63484 7.80624 7.66468 7.8102 7.69365 7.8051C7.72262 7.8 7.74931 7.78609 7.77007 7.76526L7.98412 7.55121C8.01964 7.51561 8.06718 7.49457 8.11741 7.49221C8.16765 7.48984 8.21695 7.50633 8.25566 7.53843L8.92655 8.09309C8.96232 8.12256 8.98685 8.16344 8.99601 8.20886C9.00518 8.25429 8.99843 8.30149 8.97689 8.34252Z" fill="white"/>
               </svg>
               <div class="info-window-li-txt">熱線電話：${store.whatsapp}</div>
              </div>`;
        }


      const content = `
      <div class="info-window-content-box info-window-content-box__new">
          <h4 class="info-window-h4">${store.name}</h4>

          ${productsHtml}
          <div class="info-window-list">
            <div class="info-window-li">
            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="12" viewBox="0 0 11 12" fill="none">
              <path d="M5.02362 12.0006H5.01429C4.90609 12.0005 4.79904 11.9794 4.69956 11.9387C4.60008 11.8979 4.51023 11.8384 4.4354 11.7636C4.31696 11.6451 3.24273 10.5605 2.17401 9.18647C0.731453 7.33257 0 5.85352 0 4.79194C0 2.14937 2.24945 0 5.01429 0C7.77912 0 10.0293 2.14966 10.0293 4.7918C10.0293 5.43384 9.77073 6.22046 9.26116 7.1291C8.76949 8.00537 8.03023 9.02329 7.06343 10.1549L7.05562 10.164L5.6172 11.739C5.54346 11.8206 5.45235 11.8861 5.34997 11.9312C5.2476 11.9764 5.13632 12 5.02362 12.0006ZM5.01429 7.03477C6.30856 7.03477 7.36152 6.02856 7.36152 4.79165C7.36152 3.55474 6.30856 2.54853 5.01429 2.54853C3.72001 2.54853 2.6669 3.55474 2.6669 4.79165C2.6669 6.02856 3.72001 7.03477 5.01429 7.03477Z" fill="#4D4D4D"/>
            </svg>
            <div class="info-window-li-txt">${store.address}</div>
            </div>
             <div class="info-window-li">
              <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
                <path d="M5.114 0C2.2897 0 0 2.28905 0 5.11343C0 7.93781 2.2897 10.2273 5.114 10.2273C7.9383 10.2273 10.2273 7.93781 10.2273 5.11343C10.2273 2.28905 7.93802 0 5.114 0ZM7.58553 5.83547H4.87042C4.81435 5.8356 4.75883 5.82439 4.70721 5.80251C4.63141 5.77041 4.56673 5.71669 4.52125 5.64807C4.47576 5.57945 4.45149 5.49896 4.45145 5.41663V2.70129C4.45143 2.64625 4.46225 2.59175 4.4833 2.54089C4.50434 2.49004 4.5352 2.44382 4.5741 2.40489C4.61301 2.36596 4.6592 2.33507 4.71004 2.31399C4.76088 2.29291 4.81538 2.28205 4.87042 2.28203C4.9255 2.28199 4.98005 2.29281 5.03095 2.31386C5.08185 2.33492 5.1281 2.36579 5.16706 2.40473C5.20602 2.44366 5.23693 2.4899 5.25801 2.54078C5.2791 2.59167 5.28996 2.64621 5.28996 2.70129V4.99651H7.58553C7.6406 4.99649 7.69512 5.00732 7.746 5.02838C7.79687 5.04945 7.8431 5.08033 7.88203 5.11926C7.92097 5.1582 7.95185 5.20443 7.97291 5.2553C7.99398 5.30618 8.00481 5.36071 8.00479 5.41577C8.00486 5.47087 7.99407 5.52545 7.97304 5.57637C7.952 5.6273 7.92113 5.67358 7.88218 5.71256C7.84324 5.75154 7.797 5.78246 7.7461 5.80355C7.69519 5.82464 7.64063 5.83549 7.58553 5.83547Z" fill="#4D4D4D"/>
              </svg>
              <div class="info-window-li-txt">${store.date?.[0]?.name || ""}</div>
             </div>
             ${phoneHtmlSection}
          </div>
          <a target="_blank" href="https://maps.google.com/maps?daddr=${store.address}&t=m&hl=EN" class="info-window-btn info-window-btn1">规划路线</a>
         ${phoneHtml}
        </div>
      `;
      if (window.innerWidth > 768) {
      infoWindow.setContent(content);
      infoWindow.open(map, marker.getPosition());
      } else {
        showMobileStoreModal(content);
      }
    }


    function showMobileStoreModal(htmlContent) {
      let modalContainer = document.getElementById('mobile-store-modal');

      // 如果 DOM 节点不存在则自动新建
      if (!modalContainer) {
        modalContainer = document.createElement('div');
        modalContainer.id = 'mobile-store-modal';
        modalContainer.className = 'mobile-modal-mask mobile-modal-store-mask locator-container__box';
        modalContainer.innerHTML = `
          <div class="mobile-modal-content">
            <button type="button" class="mobile-modal-close" id="mobile-modal-close-btn">&times;</button>
            <div class="mobile-modal-body"></div>
          </div>
        `;
        document.body.appendChild(modalContainer);
         document.body.style.overflow = 'hidden';


        // 绑定点击遮罩层或关闭按钮时关闭弹窗
        modalContainer.addEventListener('click', (e) => {
          if (e.target.classList.contains('mobile-modal-mask') || e.target.id === 'mobile-modal-close-btn') {
            closeMobileStoreModal();
          }
        });
      }

      // 插入新的内容
      modalContainer.querySelector('.mobile-modal-body').innerHTML = htmlContent;

      // 延时添加 active 类触发向上滑出的 CSS 动画
      requestAnimationFrame(() => {
        modalContainer.classList.add('active');
      });
    }

    // 关闭移动端弹窗的方法
    function closeMobileStoreModal() {
      const modalContainer = document.getElementById('mobile-store-modal');
      document.body.style.overflow = ""
      if (modalContainer) {
        modalContainer.classList.remove('active');
      }
    }